/* =====================================================
   assets/news-our-story-2026.js
   NuFace 2026 Redesign — Our Story "The Latest" news carousel
   MS 2026-05-22 | KC 2026-06-22: arrow re-sync + edge peek ghosting

   Mechanism: CSS scroll-snap + JS scrollBy.
   - Prev/next arrows; aria/disabled synced to scroll position.
   - Arrow state + peek ghosting are recomputed after layout/images
     settle (load + ResizeObserver), not just on init — otherwise the
     pre-layout scrollWidth (== clientWidth) left "next" stuck disabled.
   - Any card less than 80% visible inside the track viewport gets a
     white ghost overlay (the partial "peek" card at either edge),
     matching the peek treatment on the other carousels.
   ===================================================== */

(function () {
  "use strict";

  var PEEK_THRESHOLD = 0.8; /* a card <80% visible is ghosted as a peek */

  function initSection(section) {
    if (section.dataset.newsOsInited === "1") return;
    section.dataset.newsOsInited = "1";

    var track = section.querySelector("[data-news-os-track]");
    if (!track) return;

    var prevBtn = section.querySelector("[data-news-os-prev]");
    var nextBtn = section.querySelector("[data-news-os-next]");
    var cards = track.querySelectorAll(".news-our-story-2026__card");

    function step() {
      if (cards.length > 1) return cards[1].offsetLeft - cards[0].offsetLeft;
      if (cards.length === 1) return cards[0].getBoundingClientRect().width;
      return track.clientWidth;
    }

    function updateArrows() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 1;
      if (nextBtn) nextBtn.disabled = track.scrollLeft >= maxScroll - 1;
    }

    /* Toggle the ghost overlay on any card that is <80% visible within the track. */
    function updatePeek() {
      var tr = track.getBoundingClientRect();
      for (var i = 0; i < cards.length; i++) {
        var cr = cards[i].getBoundingClientRect();
        var visible = Math.max(
          0,
          Math.min(cr.right, tr.right) - Math.max(cr.left, tr.left),
        );
        var ratio = cr.width ? visible / cr.width : 0;
        cards[i].classList.toggle(
          "news-our-story-2026__card--ghost",
          ratio < PEEK_THRESHOLD,
        );
      }
    }

    var ticking = false;
    function refresh() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        updateArrows();
        updatePeek();
      });
    }

    function scrollByStep(dir) {
      track.scrollBy({ left: dir * step(), behavior: "smooth" });
    }

    if (prevBtn)
      prevBtn.addEventListener("click", function () {
        scrollByStep(-1);
      });
    if (nextBtn)
      nextBtn.addEventListener("click", function () {
        scrollByStep(1);
      });

    section.addEventListener("keydown", function (e) {
      if (e.key === "ArrowLeft") scrollByStep(-1);
      else if (e.key === "ArrowRight") scrollByStep(1);
    });

    track.addEventListener("scroll", refresh, { passive: true });
    window.addEventListener("resize", refresh);
    /* Images change the track scrollWidth after init — re-sync once they load. */
    window.addEventListener("load", refresh);
    if ("ResizeObserver" in window) {
      new ResizeObserver(refresh).observe(track);
    }

    refresh();
  }

  function initAll(scope) {
    var root = scope || document;
    var sections = root.querySelectorAll(".news-our-story-2026");
    for (var i = 0; i < sections.length; i++) initSection(sections[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (e) {
    initAll(e.target);
  });
})();
